import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pega-chat",
  "use": "pega-chat-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pega-chat\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M.5 14.2c0 4.6 2.3 8.6 6 11.2V32l5.7-4c1.2.3 2.5.4 3.8.4 8.6 0 15.5-6.4 15.5-14.2C31.5 6.3 24.6 0 16 0 7.5 0 .5 6.3.5 14.2zm8.1 10.3c-3.7-2.2-6.2-6-6.2-10.3C2.4 7.3 8.5 1.8 16 1.8s13.6 5.5 13.6 12.3c0 6.8-6.1 12.3-13.6 12.3-1.5 0-2.9-.2-4.3-.6l-3.1 2z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol